import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { FormRadioComponent } from './form-radio.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [FormRadioComponent],
  exports: [FormRadioComponent]
})
export class FormRadioModule {}
